var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"logout"},[_c('h1',{staticClass:"logout__message"},[_vm._v("You are being logged out!")]),_c('div',{staticClass:"logout__spinner-wrapper"},[_c('ActionLoader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }